module.exports = __webpack_public_path__ + "e4ef8cfea83f0eb3872bfab6460ffc99.png";